module.exports = __webpack_public_path__ + "94b6122f62705368ea03fb954c3408af.svg";